import React, { useState } from "react";
import { RxMagnifyingGlass } from "react-icons/rx";
import { useNavigate } from "react-router-dom";

function SearchBar() {
  const navigate = useNavigate();
  const [input, setInput] = useState("");

  const handleSearch = () => {
    navigate(`/search/${input}`);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="flex fles-row w-11/12 md:w-3/4 mx-auto col-span-2 border border-solid border-zinc-800 rounded-xl">
      <input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        type="search"
        name="searchText"
        id="searchText"
        placeholder="Search Here..."
        className="pl-5 pr-3 bg-transparent outline-none w-10/12 text-sm py-2"
      />
      <RxMagnifyingGlass
        size={20}
        className="text-white py-1 px-2 bg-sky-600 rounded-r-xl w-2/12 h-9 border-l border-solid border-zinc-800 cursor-pointer transition hover:bg-sky-700"
        onClick={handleSearch}
      />
    </div>
  );
}

export default SearchBar;
